import { useTranslation } from 'react-i18next'

import { Alert, ComboBox } from '@reveni-io/reveni-ui'

const CategorySelector = ({ categories = [], recommendationValue, onChangeValue, disabled }) => {
  const { t } = useTranslation()

  if (!categories.length) {
    return <Alert type="warning">{t('Aún no hay categorías configuradas en la tienda.')}</Alert>
  }

  return (
    <ComboBox
      label={t('Categoría')}
      menuItems={categories.map(c => ({ value: c.id, label: c.name }))}
      value={recommendationValue || categories[0]?.id}
      handleChange={e => onChangeValue(e.target.value)}
      fullWidth
      disabled={disabled}
    />
  )
}

export default CategorySelector
